var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[(!_vm.allBooted)?_c('c-placeholder-loader',{staticClass:"position-absolute"}):_vm._e(),(_vm.booted)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allBooted),expression:"allBooted"}]},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }